import React, { useState, Fragment } from 'react';
import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrashAlt, faArrowLeft, faAngleDown, faAngleUp, faSave, faTimesCircle } from '@fortawesome/free-solid-svg-icons';
import { ResponseSuccessModal, ResponseFailModal } from '../../modal/Response';
import StaffDelete from './StaffDelete';
import StaffkeyList from '../staffkeys/StaffkeyList';
import { dateFormatter, staffStatusFormatter } from '../../../lib/formatter';

const StaffDetail = ({
  staffId,
  countryInfoList,
  countryNumber,
  staffUpdateItem,
  staffkeyListItems,
  setStaffUpdateItem,
  selectStaffApi,
  updateStaffApi,
  listStaffkeyApi,
  moveToListPage,
  history,
}) => {
  const { t } = useTranslation();
  const [ isOpenStaffDeleteModal, setIsOpenStaffDeleteModal ] = useState(false);
  const [ isOpenStaffUpdateSuccessModal, setIsOpenStaffUpdateSuccessModal ] = useState(false);
  const [ isOpenStaffUpdateFailModal, setIsOpenStaffUpdateFailModal ] = useState(false);
  const [ messageStaffUpdateFail, setMessageStaffUpdateFail ] = useState('');
  const [ isActiveStaffInfoTab, toggleStaffInfoTab ] = useState(true);
  const [ isActiveStaffkeyListTab, toggleStaffkeyListTab ] = useState(true);

  const roleItems = [
    { key: t('data.staff_role.master'), value: 'master' },
    { key: t('data.staff_role.manager'), value: 'manager' },
    { key: t('data.staff_role.housekeeping'), value: 'housekeeping' },
    { key: t('data.staff_role.manager_mobilekey'), value: 'manager_mobilekey' },
    { key: t('data.staff_role.doorlock_setting'), value: 'doorlock_setting' },
  ];

  const updateStaff = async () => {
    try {
      await updateStaffApi();
      setIsOpenStaffUpdateSuccessModal(true);
      setTimeout(() => {
        setIsOpenStaffUpdateSuccessModal(false);
        selectStaffApi();
      }, 1500);
    } catch (error) {
      if (!error.response) setMessageStaffUpdateFail(error.message);
      else setMessageStaffUpdateFail(`${error.response.data.code}, ${error.response.data.message}`);
      setIsOpenStaffUpdateFailModal(true);
    }
  };

  return (
    <Fragment>
      <div className='content-title2'>
        <h3>
          <span onClick={moveToListPage}><FontAwesomeIcon icon={faArrowLeft}/></span>
          {t('content_title.staff_detail')}
        </h3>
      </div>
      <div className='content-title'></div>
      <div className='form-tab'>
        <p className='tab-item'>{t('tab_column.staff_detail')}</p>
      </div>
      <div className='form-card detail tab'>
        <div className='form-card-title detail'>
          <div className='form-dropdown detail first' onClick={() => setIsOpenStaffDeleteModal(true)}>
            <span><FontAwesomeIcon icon={faTrashAlt}/></span>
          </div>
          <div className='form-toggle-btn' onClick={() => toggleStaffInfoTab(!isActiveStaffInfoTab)}>
            <span hidden={isActiveStaffInfoTab}><FontAwesomeIcon icon={faAngleDown}/></span>
            <span hidden={!isActiveStaffInfoTab}><FontAwesomeIcon icon={faAngleUp}/></span>
          </div>
        </div>
        <div hidden={!isActiveStaffInfoTab}>
          <div className='inline-flex'>
            <div className='w-50'>
              <div className='card-text'>
                <p>
                  <b>{t('data_column.staff_name')}</b>
                  <span className='required'>*</span>
                </p>
                <input
                  className='card-text-input'
                  placeholder={t('placeholder.staff_name')}
                  value={staffUpdateItem.name}
                  onChange={e => setStaffUpdateItem({...staffUpdateItem, name:e.target.value})}
                />
              </div>
              <div className='card-text'>
                <p>
                  <b>{t('data_column.regist_status')}</b>
                </p>
                <input
                  className='card-text-input'
                  value={staffStatusFormatter(staffUpdateItem.status)}
                  disabled
                />
              </div>
              <div className='card-text'>
                <p>
                  <b>{t('data_column.phone_number')}</b>
                  <span className='required'>*</span>
                </p>
                <select
                  className='card-text-select'
                  value={countryNumber}
                  disabled
                >
                  {countryInfoList.map((country, index) => (
                    <option key={`country-index-${index}`} value={country.phone}>{`${country.name} ( +${country.phone} )`}</option>
                  ))}
                </select>
                <p></p>
                <input
                  className='card-text-input'
                  placeholder={t('placeholder.phone_number')}
                  value={staffUpdateItem.phoneNumber}
                  maxLength='11'
                  disabled
                />
              </div>
            </div>
            <div className='w-50'>
              <div className='card-text'>
                <p>
                  <b>{t('data_column.role')}</b>
                  <span className='required'>*</span>
                </p>
                <select
                  className='card-text-select'
                  value={staffUpdateItem.role}
                  onChange={e => setStaffUpdateItem({...staffUpdateItem, role:e.target.value})}
                >
                  <option value='' hidden>{t('placeholder.role')}</option>
                  {roleItems.map((role, index) => (
                    <option key={index} value={role.value}>{role.key}</option>
                  ))}
                </select>
              </div>
              <div className='card-text'>
                <p>
                  <b>{t('data_column.created_at')}</b>
                </p>
                <input
                  className='card-text-input'
                  value={dateFormatter(staffUpdateItem.createdAt)}
                  disabled
                />
              </div>
              <div className='card-text'>
                <p>
                  <b>{t('data_column.updated_at')}</b>
                </p>
                <input
                  className='card-text-input'
                  value={dateFormatter(staffUpdateItem.updatedAt)}
                  disabled
                />
              </div>
            </div>
          </div>
          <div className='card-foot'>
            <div className='form-item-cancel'>
              <button className='btn-item-cancel' onClick={moveToListPage}>
                <FontAwesomeIcon icon={faTimesCircle} style={{paddingRight:'3px'}}/><span>{t('button.cancel')}</span>
              </button>
            </div>
            <div className='form-item-add center detail'>
              <button className='btn-item-add' onClick={updateStaff}>
                <FontAwesomeIcon icon={faSave} style={{paddingRight:'2px'}}/><span>{t('button.save')}</span>
              </button>
            </div>
          </div>
        </div>
      </div>
      <div className='form-tab-wrap'>
        <div className='form-tab'>
          <p className='tab-item'>{t('tab_column.staffkey_list')}</p>
        </div>
        <div className='form-tab-item'>
          <div className='form-card-title detail'>
            <div className='form-toggle-btn' onClick={() => toggleStaffkeyListTab(!isActiveStaffkeyListTab)}>
              <span hidden={isActiveStaffkeyListTab}><FontAwesomeIcon icon={faAngleDown}/></span>
              <span hidden={!isActiveStaffkeyListTab}><FontAwesomeIcon icon={faAngleUp}/></span>
            </div>
          </div>
          <div className='form-key-foot' hidden={!isActiveStaffkeyListTab}>
            <StaffkeyList
              staffId={staffId}
              staffRole={staffUpdateItem.role}
              staffkeyListItems={staffkeyListItems}
              reload={listStaffkeyApi}
              history={history}
            />
          </div>
        </div>
      </div>
      <StaffDelete
        isOpen={isOpenStaffDeleteModal}
        toggle={() => setIsOpenStaffDeleteModal(!isOpenStaffDeleteModal)}
        reload={() => moveToListPage()}
        staffId={staffId}
        staffName={staffUpdateItem.name}
      />
      <ResponseSuccessModal
        isOpen={isOpenStaffUpdateSuccessModal}
        toggle={() => setIsOpenStaffUpdateSuccessModal(!isOpenStaffUpdateSuccessModal)}
        message={t('success_message.edit_staff')}
      />
      <ResponseFailModal
        isOpen={isOpenStaffUpdateFailModal}
        toggle={() => setIsOpenStaffUpdateFailModal(!isOpenStaffUpdateFailModal)}
        message={messageStaffUpdateFail || t('error_message.edit_staff')}
      />
    </Fragment>
  );
};

export default StaffDetail;